import script from "./StatusMint.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusMint.vue?vue&type=script&setup=true&lang=js"

import "./StatusMint.vue?vue&type=style&index=0&id=88089630&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88089630"]])

export default __exports__